import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@store/authStore';
import { ROUTES } from '@/constants';
import AuthLayout from './AuthLayout';

const LayoutProvider = ({ children, authLayoutProps = {}, appLayoutProps = {}, redirectIfAuthenticated = false }) => {
  const navigate = useNavigate();
  const { setAuthType, authType, isAuthenticated } = useAuthStore();
  const location = useLocation();
  const prevLocationRef = useRef();

  useEffect(() => {
    if (location.pathname === ROUTES.HOME.path) {
      // Only set authType to 'home' on initial load or when navigating TO homepage from another page
      const isNavigatingToHomepage = prevLocationRef.current && prevLocationRef.current.pathname !== ROUTES.HOME.path;
      const isInitialHomepageLoad = !prevLocationRef.current;

      // Only redirect authenticated users if explicitly requested
      if (redirectIfAuthenticated && isAuthenticated) {
        navigate(ROUTES.DASHBOARD.path);
        return;
      }

      // Only reset to 'home' when first arriving at homepage, not on every render
      if (isNavigatingToHomepage || isInitialHomepageLoad) {
        setAuthType('home');
      }
    }

    // Update previous location reference
    prevLocationRef.current = location;
  // Note: authType intentionally excluded to prevent resetting when user clicks buttons
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, setAuthType, isAuthenticated, navigate, redirectIfAuthenticated]);

  return (
    <AuthLayout {...authLayoutProps}>
      {children}
    </AuthLayout>
  );
};

export default LayoutProvider;
